export default "__VITE_ASSET__DcHx8QIz__"